import { render, staticRenderFns } from "./labelData.vue?vue&type=template&id=75208d78&scoped=true&"
import script from "./labelData.vue?vue&type=script&lang=js&"
export * from "./labelData.vue?vue&type=script&lang=js&"
import style0 from "./labelData.vue?vue&type=style&index=0&id=75208d78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75208d78",
  null
  
)

export default component.exports